export enum DType {
    // Default data types
    STRING, NUMBER, BOOLEAN,
    // Advanced data types
    COLOR,
    UNKNOWN
}
